import { createNamespacedHelpers } from 'vuex'
import Constants from '@constants'

const { mapGetters: requestGetters, mapActions: requestActions } =
  createNamespacedHelpers(`form/${Constants.REQUEST}`)
const { mapGetters: problemGetters, mapActions: problemActions } =
  createNamespacedHelpers(`form/${Constants.PROBLEM}`)
const { mapGetters: changeGetters, mapActions: changeActions } =
  createNamespacedHelpers(`form/${Constants.CHANGE}`)
const { mapGetters: projectGetters, mapActions: projectActions } =
  createNamespacedHelpers(`form/${Constants.PROJECT}`)
const { mapGetters: releaseGetters, mapActions: releaseActions } =
  createNamespacedHelpers(`form/${Constants.RELEASE}`)
const { mapGetters: assetGetters, mapActions: assetActions } =
  createNamespacedHelpers(`form/${Constants.ASSET}`)
// const { mapGetters: cmdbGetters, mapActions: cmdbActions } =
//   createNamespacedHelpers(`form/${Constants.CMDB}`)

const { mapGetters: userGetters, mapActions: userActions } =
  createNamespacedHelpers(`form/${Constants.USER}`)

const { mapGetters: feedbackGetters, mapActions: feedbackActions } =
  createNamespacedHelpers(`form/${Constants.FEEDBACK}`)
const { mapGetters: productGetters, mapActions: productActions } =
  createNamespacedHelpers(`form/${Constants.PRODUCT}`)

const { mapGetters: vendorGetters, mapActions: vendorActions } =
  createNamespacedHelpers(`form/${Constants.VENDOR}`)

const { mapGetters: contractGetters, mapActions: contractActions } =
  createNamespacedHelpers(`form/${Constants.CONTRACT}`)

const { mapGetters: purchaseGetters, mapActions: purchaseActions } =
  createNamespacedHelpers(`form/${Constants.PURCHASE}`)

const { mapGetters: taskGetters, mapActions: taskActions } =
  createNamespacedHelpers(`form/${Constants.TASK}`)

const { mapGetters: mspCompanyGetters, mapActions: mspCompanyActions } =
  createNamespacedHelpers(`form/${Constants.MSP_COMPANY}`)

const {
  mapGetters: softwareLicenseGetters,
  mapActions: softwareLicenseActions,
} = createNamespacedHelpers(`form/${Constants.SOFTWARE_LICENSE}`)

export const FormComputed = {
  ...userGetters(['form']),
  ...requestGetters({
    requestLoading: 'loading',
    requestPortalFields: 'portalFields',
    requestPortalEditableFields: 'portalEditableFields',
    requestForm: 'form',
    requestAttachmentFields: 'attachmentFields',
    requestFields: 'getFields',
    requestHiddenFields: 'hiddenFields',
  }),
  ...problemGetters({
    problemLoading: 'loading',
    problemForm: 'form',
    problemAttachmentFields: 'attachmentFields',
    problemFields: 'getFields',
    problemHiddenFields: 'hiddenFields',
  }),
  ...changeGetters({
    changeLoading: 'loading',
    changeForm: 'form',
    changeAttachmentFields: 'attachmentFields',
    changeFields: 'getFields',
    changeHiddenFields: 'hiddenFields',
  }),
  ...projectGetters({
    projectLoading: 'loading',
    projectAttachmentFields: 'attachmentFields',
    projectFields: 'getFields',
    projectForm: 'form',
    projectPortalFields: 'portalFields',
    projectPortalEditableFields: 'portalEditableFields',
  }),
  ...releaseGetters({
    releaseLoading: 'loading',
    releaseForm: 'form',
    releaseAttachmentFields: 'attachmentFields',
    releaseFields: 'getFields',
    releaseHiddenFields: 'hiddenFields',
  }),
  ...assetGetters({
    assetLoading: 'loading',
    assetForm: 'form',
    assetAttachmentFields: 'attachmentFields',
    assetFields: 'assetFields',
    cmdbFields: 'cmdbFields',
  }),
  // ...cmdbGetters({
  //   cmdbLoading: 'loading',
  //   cmdbForm: 'form',
  //   cmdbAttachmentFields: 'attachmentFields',
  //   cmdbFields: 'getFields',
  // }),
  ...userGetters({
    userLoading: 'loading',
    userForm: 'form',
    userAttachmentFields: 'attachmentFields',
    userFields: 'getFields',
  }),
  ...feedbackGetters({
    feedbackLoading: 'loading',
    feedbackForm: 'form',
    feedbackAttachmentFields: 'attachmentFields',
    feedbackFields: 'getFields',
  }),
  ...productGetters({
    productLoading: 'loading',
    productForm: 'form',
    productAttachmentFields: 'attachmentFields',
    productFields: 'getFields',
  }),
  ...vendorGetters({
    vendorLoading: 'loading',
    vendorForm: 'form',
    vendorAttachmentFields: 'attachmentFields',
    vendorFields: 'getFields',
  }),
  ...contractGetters({
    contractLoading: 'loading',
    contractPortalFields: 'portalFields',
    contractForm: 'form',
    contractAttachmentFields: 'attachmentFields',
    contractFields: 'getFields',
  }),
  ...purchaseGetters({
    purchaseLoading: 'loading',
    purchasePortalFields: 'portalFields',
    purchaseForm: 'form',
    purchaseAttachmentFields: 'attachmentFields',
    purchaseFields: 'getFields',
  }),
  ...mspCompanyGetters({
    msp_companyLoading: 'loading',
    msp_companyForm: 'form',
    msp_companyAttachmentFields: 'attachmentFields',
    msp_companyFields: 'getFields',
  }),
  ...taskGetters({
    taskLoading: 'loading',
    taskForm: 'form',
    taskAttachmentFields: 'attachmentFields',
    taskFields: 'getFields',
    taskPortalFields: 'portalFields',
    taskPortalEditableFields: 'portalEditableFields',
  }),
  ...softwareLicenseGetters({
    software_licenseLoading: 'loading',
    software_licenseForm: 'form',
    software_licenseAttachmentFields: 'attachmentFields',
    software_licenseFields: 'getFields',
  }),
}

export const FormActions = {
  ...requestActions({
    fetchRequestForm: 'fetch',
  }),
  ...problemActions({
    fetchProblemForm: 'fetch',
  }),
  ...changeActions({
    fetchChangeForm: 'fetch',
  }),
  ...projectActions({
    fetchProjectForm: 'fetch',
  }),
  ...releaseActions({
    fetchReleaseForm: 'fetch',
  }),
  ...userActions({
    fetchUserForm: 'fetch',
  }),
  ...assetActions({
    fetchAssetForm: 'fetch',
  }),
  // ...cmdbActions({
  //   fetchCmdbForm: 'fetch',
  // }),
  ...feedbackActions({
    fetchFeedbackForm: 'fetch',
  }),
  ...productActions({
    fetchProductForm: 'fetch',
  }),
  ...vendorActions({
    fetchVendorForm: 'fetch',
  }),
  ...contractActions({
    fetchContractForm: 'fetch',
  }),
  ...purchaseActions({
    fetchPurchaseForm: 'fetch',
  }),
  ...mspCompanyActions({
    fetchmsp_companyForm: 'fetch',
  }),
  ...taskActions({
    fetchTaskForm: 'fetch',
  }),
  ...softwareLicenseActions({
    fetchSoftware_licenseForm: 'fetch',
  }),
}
